module.exports = __webpack_public_path__ + "static/media/rocket-signup.add02c6d.png";